import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';

import { Router } from '@angular/router';
import { User } from '../models/auth';
import { environment } from '../../../../../../public/environments/environment';
import { ApiServiceService } from './api-service.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  menuLoaded = new BehaviorSubject<any>(false);
  generalRefreshDetails = new BehaviorSubject<boolean>(false);

  public currentUserSubject: BehaviorSubject<User | null> = new BehaviorSubject<User | null>(null);

  constructor(
    private http: HttpClient,
    private router: Router,
    private apiService: ApiServiceService
  ) {
    const authLS = localStorage.getItem('authUser');
    const ls = authLS ? JSON.parse(authLS) as User : '';
    if (ls) {
      this.currentUserSubject.next(ls);
    }
  }

  public get currentUserValue(): User | null {
    return this.currentUserSubject.value;
  }

  register(data: any): any {
    return this.apiService.post(`${environment.apiUrl}/authentication/register`, data).pipe(catchError(this.handleError));
  }

  registerWithGoogle(data: any): any {
    return this.apiService.post(`${environment.apiUrl}/authentication/social/google-register`, data).pipe(map((res: any) => {
      if (res?.data?.user) {
        let user = res.data?.user;
        this.currentUserSubject.next(user);
        localStorage.setItem('authUser', JSON.stringify(user))
        localStorage.setItem("token", JSON.stringify(res.data?.token));
      }
      return res;
    }), catchError(this.handleError));
  }
  registerWithLinkedIn(data: any): any {
    return this.apiService.post(`${environment.apiUrl}/authentication/social/linkedin-register`, data).pipe(map((res: any) => {
      let user = res.data?.user;
      this.currentUserSubject.next(user);
      localStorage.setItem('authUser', JSON.stringify(user))
      localStorage.setItem("token", JSON.stringify(res.data?.token));
      return res;
    }), catchError(this.handleError));
  }

  checkEmail(email: any) {
    return this.apiService.post(`${environment.apiUrl}/authentication/check-email`, email).pipe(catchError(this.handleError));
  }

  sendVerification(data: any) {
    return this.apiService.post(`${environment.apiUrl}/authentication/send-verification`, data).pipe(catchError(this.handleError));
  }

  verifiyAccount(data: any) {
    return this.apiService.post(`${environment.apiUrl}/authentication/verify-account`, data).pipe(catchError(this.handleError));
  }

  login(data: any): any {
    return this.apiService.post(`${environment.apiUrl}/authentication/login`, data).pipe(map((res: any) => {
      if (res?.data?.user) {
        let user = res.data?.user;
        this.currentUserSubject.next(user);
        localStorage.setItem('authUser', JSON.stringify(user))
        localStorage.setItem("token", JSON.stringify(res.data?.token));
        if (!localStorage.getItem('language')) {
          localStorage.setItem('language', 'ar');
        }
      }
      return res;
    }), catchError(this.handleError));
  }

  loginWithGoogle(token: any): any {
    return this.apiService.post(`${environment.apiUrl}/authentication/social/google-login`, token).pipe(map((res: any) => {
      let user = res.data?.user;
      this.currentUserSubject.next(user);
      localStorage.setItem('authUser', JSON.stringify(user))
      localStorage.setItem("token", JSON.stringify(res.data?.token));
      return res;
    }), catchError(this.handleError));
  }

  loginWithLinkedIn(token: any): any {
    return this.apiService.post(`${environment.apiUrl}/authentication/social/linkedin-login`, token).pipe(map((res: any) => {
      if (res?.data?.user) {
        let user = res.data?.user;
        this.currentUserSubject.next(user);
        localStorage.setItem('authUser', JSON.stringify(user))
        localStorage.setItem("token", JSON.stringify(res.data?.token));
      }
      return res;
    }), catchError(this.handleError));
  }

  completeProfile(data: any) {
    return this.apiService.post(`${environment.apiUrl}/authentication/complete-personal-information`, data).pipe(catchError(this.handleError));
  }

  forgetPassword(data: any) {
    return this.apiService.post(`${environment.apiUrl}/authentication/forget-password`, data).pipe(catchError(this.handleError));
  }

  resetPassword(data: any, code: any) {
    return this.apiService.post(`${environment.apiUrl}/authentication/set-my-password/${code}`, data).pipe(map((res: any) => {
      // let user = res.data?.user;
      // console.log(res.data)
      // this.currentUserSubject.next(user);
      // localStorage.setItem('authUser', JSON.stringify(user))
      // localStorage.setItem("token", JSON.stringify(res.data?.token));
    }), catchError(this.handleError));
  }

  CheckToken(Token: string) {
    return this.apiService.get(`${environment.apiUrl}/authentication/check-token/${Token}`)
      .pipe(catchError(this.handleError));
  }

  logout() {
    this.clearUserData();
    this.router.navigate(['/login']);
  }

  clearUserData() {
    localStorage.removeItem('authUser');
    localStorage.removeItem('token');
    this.currentUserSubject.next(null);
  }


  GetNotifiactions(model: any) {
    return this.apiService.get(`${environment.apiUrl}/notifications`, model);
  }

  MarkAllNotificationsAsRead() {
    return this.apiService.post(`${environment.apiUrl}/mark_notifications_read`);
  }

  ConnectToSocket(model: any) {
    return this.apiService.post(environment.apiUrl + '/web/real-time-register', model)
      .pipe(catchError(this.handleError));
  }

  handleError(error: any) {
    return throwError(error);
  }
}
